export const REGION = 'us-east-1';

// WITHOUT DUO LOGIN CONFIG

export const DIRECT_CLIENT_ID = '6vr1jqmahnqps6oabkqh61k8n8';

// DUO LOGIN CONFIG START

export const USER_POOL_CLIENT_ID = '5mtlbd5i102sn28oumlvrf5isv';

export const COGNITO_DOMAIN = 'us-east-1cuuog0n1a.auth.us-east-1.amazoncognito.com';

// export const FRONT_END_DOMAIN = "d3iqyab8hc1p2w.cloudfront.net";

export const FRONT_END_DOMAIN = "app.legalstream.org";
export const BACK_END_API_URL = "https://app.legalstream.org";

// export const BACK_END_API_URL = "http://localhost:8081";

export const DOCUMENT_BUILDER_BACKEND = BACK_END_API_URL;
// export const DOCUMENT_BUILDER_BACKEND = 'http://localhost:8080';

export const VERIFICATION_METHOD = 'code';

export const SCPOPES = ["email", "profile", "openid"];

export const TIMEZONE = 'America/New_York';

// DUO LOGIN CONFIG END

export const DOCUMENT_TYPES = ['ANSWER', 'BK', 'COMM', 'COMPLAINT', 'COUNTERCLAIM', 'DEMAND', 'DISMISSAL', 'DISPUTE', 'DOME', 'GARN', 'JUDGMENT', 'LIEN', 'MISC', 'PSOJ', 'ROG', 'ROL', 'ROS', 'SOJ', 'VOD'];

export const REPORT_IDs = {
  ccmr: "3d2a4cdd-918b-4c44-96ea-35965578f134",
  dq: "25bf41b6-1e12-4bc7-b718-cb625e9e7fa9",
  "ccmr-sla": "5ced832a-613b-4162-8d45-6cce8b9bb4b0",
  "operational-dashboard": "17ba8f64-05c2-42e1-8069-7074682f9520",
  "client-dashboard": "bd703ed2-429b-415c-ac88-fd422ad222c9"
};

export const US_STATES = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" }
];

export const DOCUMENT_TYPE_TO_STATUS_MAP = {
    JUDGMENT:    'legal',
    COUNTERCLAIM:'legal',
    ANSWER:      'pending',
    COMPLAINT:   'active',
    DEMAND:      'warning',
    ROS:         'active',
    DISPUTE:     'error',
    VOD:         'secondary',
    GARN:        'warning',
    LIEN:        'error',
    DISMISSAL:   'success',
    SOJ:         'legal',
    ROG:         'pending',
    DOME:        'default',
    BK:          'error',
    COMM:        'active',
    MISC:        'default',
    PSOJ:        'legal',
};

export const NAMING_ISSUE_REASON_TO_STATUS_MAP = {
  INVALID_FILE_NO: 'warning',
  NOT_PDF: 'warning',
  INVALID_FORMAT: 'warning',
  INVALID_DOCTYPE: 'error',
  AMBIGUOUS_DOCTYPE: 'error',
  FILENO_NOT_FOUND: 'secondary',
};

export const ARCHIVED_DOCUMENT_STATUS_TO_STATUS_MAP = {
  PROCESSED: 'legal',
  SKIPPED: 'warning',
  FAILED: 'error'
}

export const TAB_BADGE_STATUSES = [ "draft", "settled", "active", "overdue"];